/** The composer's placeholder when no sender needs naming. */
export const DEFAULT_COMPOSER_PLACEHOLDER = 'Write a message';

/**
 * Compose the placeholder text shown inside the chat composer.
 *
 * In Ask Anonymously / Primum support flows the composer can be sent either
 * as the named expert (expert relay) or as Primum Support; the placeholder
 * mirrors the active sender so the author always knows which identity will
 * appear on the recipient's side.
 */
export function expertRelayComposerPlaceholder(options: {
  canSendAsExpertRelay: boolean;
  sendAsExpertRelay: boolean;
  expertLabel: string;
  supportCaption: string;
  defaultToSupportCaption?: boolean;
}) {
  const {
    canSendAsExpertRelay,
    sendAsExpertRelay,
    expertLabel,
    supportCaption,
    defaultToSupportCaption = false,
  } = options;

  if (!canSendAsExpertRelay) {
    if (defaultToSupportCaption) {
      return `Write a message as ${supportCaption}`;
    }

    return DEFAULT_COMPOSER_PLACEHOLDER;
  }

  if (sendAsExpertRelay) {
    return `Write a message as ${expertLabel}`;
  }

  return `Write a message as ${supportCaption}`;
}
